<script setup lang="ts">
import { $createParagraphNode, $getRoot, $isParagraphNode, COLLABORATION_TAG } from "lexical";
import { useLexicalComposer } from "lexical-vue";
import { onMounted, onUnmounted } from "vue";

const editor = useLexicalComposer();

const ensureTrailingParagraph = () => {
  editor.update(() => {
    const root = $getRoot();
    const lastChild = root.getLastChild();
    if (!lastChild) {
      return;
    }
    if ($isParagraphNode(lastChild) && lastChild.getTextContentSize() === 0) {
      return;
    }

    const paragraph = $createParagraphNode();
    lastChild.insertAfter(paragraph);
  });
};

let unregisterListeners: () => void;

onMounted(() => {
  unregisterListeners = editor.registerUpdateListener(({ tags }) => {
    if (!tags.has(COLLABORATION_TAG)) {
      ensureTrailingParagraph();
    }
  });
});

onUnmounted(() => {
  unregisterListeners?.();
});
</script>

<template>
  <slot />
</template>
